import {Toast} from 'mint-ui'
import 'mint-ui/lib/style.min.css'

/**
 * mint-ui toast
 */
export const tips = (msg, duration=1500) => {
  Toast({
    message: msg,
    position: 'middle',
    duration: duration
  })
}
export const parseUrl = (url) => {
  var paraString = url.substring(url.indexOf("=") + 1, url.length);
 
  
  return paraString;
}


export const getBase64Image = function getBase64Image(image) {
  var canvas = document.createElement("canvas");
  canvas.width = image.width;
  canvas.height = image.height;
  var context = canvas.getContext("2d");
  context.drawImage(image, 0, 0, image.width, image.height);
  // 这里是不支持跨域的
  var base64 = canvas.toDataURL("image/" + jpg);
  return base64;

}


// WEBPACK FOOTER //
// ./src/common/js/util.js